import { forwardRef } from "react";
import type { InputProps } from "react-select";

const PhoneInputComponent = forwardRef<HTMLInputElement, InputProps>(
  (props, ref) => (
    <input
      ref={ref}
      {...props}
      className="w-full rounded-full bg-primary-50 py-4 pr-6 placeholder:text-primary-600 focus:outline-none"
    />
  )
);

export default PhoneInputComponent;
